import axios from '../util/request'
import qs from 'qs'
const md5 = require('js-md5')
const stamp = Date.now()

export const AreaList = (data) => {
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.data_type}jushou2018shrosun`)
  return axios.post('/interface/getAreaList',qs.stringify(data))
}

export const huntStore = (data) => {
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.data_type}jushou2018shrosun`)
  return axios.post('/interface/huntStore',qs.stringify(data))
}
